//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Burn',
  data() {
    return {
      form:{
        burn_area:'',
        weight:'',
        time:'',
        replenished:'',
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        let result24 = 0
        result24 = form.burn_area * form.weight * 2.6 + 2000

        let prev = 0
        let next = 0

        if (form.time < 2) {
          prev = result24 * (1/2 * (form.time / 2)) - form.replenished
          next = result24  - prev - form.replenished
        }else {
          prev = result24 * (1/2 + ((form.time - 2) / 22) * 1/2) - form.replenished
          next = result24  - prev - form.replenished
        }
        self.hasScore = true


        // 补液量已足够
        if (prev < 0) {
          prev = 0
          next = result24 - form.replenished
        } else {
          next = result24 - prev - form.replenished
        }
        if (next < 0) {
          next = 0
        }

        return {
          fluid24: String(result24),
          fluid_prev: String(prev == 0 ? '补液量已足够' : prev.toFixed(2)),
          fluid_next: String(next == 0 ? '补液量已足够' : next.toFixed(2))
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/Burn.vue